var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_shared-key.js
// module id = 628
// module chunks = 0